import { createSlice } from "@reduxjs/toolkit";

const initialRoleState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  lastError: null,
  roleForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const roleSlice = createSlice({
  name: "role",
  initialState: initialRoleState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		roleFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		roleAllFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    roleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.role.push(action.payload.role);
    },
    roleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.role.filter(el => el.role_id !== action.payload.id);
    },
    getRole: (state, action) => {
      state.actionsLoading = false;
      state.roleForEdit = action.payload.roleForEdit;
      state.error = null;
    },
    // updateProduct
    roleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.role = state.entities.role.map(entity => {
        if (entity.role_id === action.payload.role.role_id) {
          return action.payload.role;
        }
        return entity;
      });
    },
  },
});
